/**
 * Cockpit filter by operator task definition (the job we send and pay).
 *
 * - Absent query param → all definitions (null)
 * - Explicit empty (`taskDefinitionIds=` ) → none selected ([])
 * - Comma list → include-list subset
 */

export function parseTaskDefinitionIds(raw: string | undefined | null): number[] | null {
  if (raw == null) {
    return null;
  }
  const trimmed = raw.trim();
  if (trimmed.length === 0) {
    return [];
  }

  const ids = trimmed
    .split(',')
    .map((part) => Number(part.trim()))
    .filter((id) => Number.isInteger(id) && id > 0);

  if (ids.length === 0) {
    return null;
  }

  return Array.from(new Set(ids));
}

export function expandWithRemovalChildren(
  postingIds: number[],
  parentToRemoval: Map<number, number>,
): Set<number> {
  const allowed = new Set<number>(postingIds);
  for (const postingId of postingIds) {
    const removalId = parentToRemoval.get(postingId);
    if (typeof removalId === 'number' && removalId > 0) {
      allowed.add(removalId);
    }
  }
  return allowed;
}

export function taskMatchesFilter(
  taskDefinitionId: number | null | undefined,
  allowed: Set<number> | null,
): boolean {
  if (allowed === null) {
    return true;
  }
  if (taskDefinitionId == null || taskDefinitionId <= 0) {
    return false;
  }
  return allowed.has(taskDefinitionId);
}

export function serializeTaskDefinitionIds(ids: number[]): string {
  return Array.from(new Set(ids.filter((id) => Number.isInteger(id) && id > 0)))
    .sort((a, b) => a - b)
    .join(',');
}
